import { USER_REQUEST, CREATE_USER, GET_USERS, UPDATE_USER, DELETE_USER, USER_REQUEST_FAILURE } from '../types';

const initialState = {
  users: [],
  loading: false,
  error: null,
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case USER_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_USERS: {
      return {
        ...state,
        users: [...action.payload],
        loading: false,
        error: null
      }
    }
    case CREATE_USER:
      return {
        ...state,
        users: [action.payload, ...state.users],
        loading: false,
        error: null
      };
    case UPDATE_USER:
      const usersData = state.users.slice(0);
      const uIndex = usersData.findIndex((data) => data.id === action.payload.id);
      usersData.splice(uIndex, 1, { ...action.payload.data });
      return {
        ...state,
        users: [ ...usersData ],
        loading: false,
        error: null
      };
    case DELETE_USER:
      const users = state.users?.slice(0);
      const index = users.findIndex((data) => data.id === action.id);
      if (index > -1) {
        users.splice(index, 1);
      }
      return {
        ...state,
        users: [...users],
        loading: false,
        error: null
      }
    case USER_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default userReducer;
